import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code"]

  connect() {
    console.log("Support Access Modal controller connected")
  }

  copyCode(event) {
    event.preventDefault()

    const code = event.currentTarget.dataset.code
    const button = event.currentTarget

    // Copy to clipboard
    navigator.clipboard.writeText(code).then(() => {
      // Save original button content
      const originalHTML = button.innerHTML

      // Update button to show success
      button.innerHTML = '<i class="fa-solid fa-check me-1"></i> Copied!'
      button.classList.remove('btn-outline-primary')
      button.classList.add('btn-success')

      // Reset button after 2 seconds
      setTimeout(() => {
        button.innerHTML = originalHTML
        button.classList.remove('btn-success')
        button.classList.add('btn-outline-primary')
      }, 2000)

      // Show toast notification
      if (typeof toastr !== 'undefined') {
        toastr.success(I18n.t('dashboard.support_access.success.copied'))
      }
    }).catch(err => {
      console.error('Failed to copy code:', err)
      if (typeof toastr !== 'undefined') {
        toastr.error(I18n.t('dashboard.support_access.error.copy_failed'))
      }
    })
  }
}
